import { combineReducers } from "@reduxjs/toolkit";
import ModalSlice from "../slices/ModalSlice";
import reservationReducer from "../slices/ReservationSlice";
import ShopSlice from "../slices/ShopSlice";
import SpecialSlice from "../slices/SpecialSlice";
import UserSlice from "../slices/UserSlice";

const rootReducer = combineReducers({
  Modal: ModalSlice,
  User: UserSlice,
  Shop: ShopSlice,
  Special: SpecialSlice,
  Reservation: reservationReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
